import { Navigate } from "react-router";

export const ProtectedRoute = ({ element }) => {
  return element;
  let token = localStorage.getItem("stats-insight-login");
  if (token === null) {
    return <Navigate to="/login" />;
  } else {
    let loginStamp = JSON.parse(
      localStorage.getItem("stats-insight-login-info"),
    );
    let loginTimeStamp = new Date(loginStamp.expiredTime),
      current = new Date();
    if (loginTimeStamp < current) {
      localStorage.removeItem("stats-insight-login");
      localStorage.removeItem("stats-insight-login-info");
      return <Navigate to="/login" />;
    } else {
      let newInfo = {
        ...loginStamp,
        expiredTime: current.setHours(current.getHours() + 12),
      };
      localStorage.setItem("stats-insight-login-info", JSON.stringify(newInfo));
      return element;
    }
  }
};
